import React from "react";

function WhyChCardano() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Cardano for Your Blockchain Project?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Cardano stands out for its unique proof-of-stake (PoS)
                  consensus mechanism, which provides a sustainable,
                  eco-friendly solution for blockchain projects. Built on
                  peer-reviewed research and developed through a rigorous
                  academic process, Cardano offers scalability, security, and
                  interoperability, making it ideal for DApps, DeFi solutions,
                  and tokenized applications.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyChCardano;
